/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Member } from './Member';
export interface MemberPermissions {
  permissions?: Array<MemberPermissions.Permissions>;

  member?: Member;
}

export namespace MemberPermissions {
  export enum Permissions {
    ADMIN = <any>'ADMIN',
    EXPORT = <any>'EXPORT',
    EXPORT_FINANCIAL = <any>'EXPORT_FINANCIAL',
    CREATE_ACTIVITY_NOTE = <any>'CREATE_ACTIVITY_NOTE',
    EDIT_USER_ACCESS = <any>'EDIT_USER_ACCESS',
    CREATE_MEMBER = <any>'CREATE_MEMBER',
    CREATE_ORDER = <any>'CREATE_ORDER',
    EDIT_MEMBER_TAGS = <any>'EDIT_MEMBER_TAGS',
    CREATE_REFUND = <any>'CREATE_REFUND',
    CREATE_ACTIVITY_POINTS = <any>'CREATE_ACTIVITY_POINTS',
    EDIT_MEMBER_EDU = <any>'EDIT_MEMBER_EDU',
    EDIT_MEMBER_CERT = <any>'EDIT_MEMBER_CERT',
    SUPERUSER = <any>'SUPERUSER',
    CHAPTERSADMIN = <any>'CHAPTERSADMIN',
  }
}



// WEBPACK FOOTER //
// ./src/common/api/models/MemberPermissions.ts